// extracted by mini-css-extract-plugin
export default {"title":"CTABanner_title__FIKYa","pitstopGif":"CTABanner_pitstopGif__lp9Bq"};